<!-- Skeleton is for the initial (unfiltered) load only. Showing it for a filtered refetch would
     tear down the display and lose the search text mid-typing. -->
<ng-container *ngIf="((loading$ | async) || loadingPage) && visibleOrdersCount === 0 && !hasActiveQuery; else loadedContent">
  <div class="orders-skeleton" role="region" aria-busy="true" aria-label="Loading orders">
    <hmt-skeleton-loader
      *ngFor="let _ of [1, 2, 3, 4, 5, 6]"
      height="72"
      [styles]="{ 'width': '100%', 'border-radius.px': '8', 'margin-bottom.px': '12' }">
    </hmt-skeleton-loader>
  </div>
</ng-container>

<ng-template #loadedContent>
<!-- Only the unfiltered "job has no orders" case swaps in the empty state. A filtered zero-result
     keeps the display mounted so the search / filter controls stay reachable. -->
<ng-container *ngIf="visibleOrdersCount === 0 && !hasActiveQuery; else ordersDisplay">
  <div class="empty-container">
    <div class="empty-title">
      <span>Orders ({{ visibleOrdersCount }})</span>
      <img class="title-icon" src="assets/icons/job-planning/gift.svg" alt="" aria-hidden="true" />
    </div>
    <div class="empty-state" role="region" aria-label="No orders">
      <img class="empty-illustration" src="assets/icons/job-planning/order-not-found.svg" alt="No orders found" />
      <div class="empty-text">No Orders Found</div>
      <div class="empty-sub">{{ caption }}</div>
      <div class="empty-ctas">
        <button class="btn primary" type="button" (click)="!isReadOnly && selectOrders()" [disabled]="isReadOnly">Select Orders</button>
        <button class="btn primary" type="button" (click)="!isReadOnly && openFileUpload()" [disabled]="isReadOnly" *ngIf="jobFile?.workflowId === 'LF-DO-FTL'">Import Orders</button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #ordersDisplay>
  <div class="orders-display-wrapper">
    <div class="orders-content">
      <hmt-job-plan-order-display
        #orderDisplayComponent
        [orders]="orders"
        [grouped]="grouped"
        [serverGroups]="serverGroups"
        [totalMatching]="totalElements"
        [selectable]="false"
        [deletable]="!showOnlySelected"
        [showHeader]="true"
        [showSearch]="true"
        [showAddButton]="true"
        [jobType]="jobType"
        [hideCheckboxes]="showOnlySelected"
        [showMoveDropdown]="showOnlySelected"
        [containers]="moveTargetContainers"
        [selectedLoadId]="selectedLoadId"
        (queryChange)="onQueryChange($event)"
        (loadMoveClicked)="onLoadSelected($event)"
        (addButtonClicked)="selectOrders()">
      </hmt-job-plan-order-display>
    </div>

    <hmt-custom-pagination
      *ngIf="!showOnlySelected && totalElements > pageSize"
      [totalItems]="totalElements"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [loading]="loadingPage"
      [showNoDataMessage]="false"
      (pageChange)="onPageChange($event)">
    </hmt-custom-pagination>
    <div class="move-button-container">
      <span class="selected-orders-text" *ngIf="hasSelectedOrders() && !showOnlySelected">
        <span class="grip-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </span>
        {{ selectedOrdersCount }} Orders Selected from {{ visibleOrdersCount }} Orders
      </span>
      <div class="button-group" *ngIf="!showOnlySelected">
        <button class="btn delete-btn" type="button" (click)="onDeleteSelected()" [disabled]="!hasSelectedOrders()">
          <img src="assets/booking-engine/icons/trash.svg" alt="Delete" class="delete-icon">
          <span>Delete Selected</span>
        </button>
        <button class="btn move-btn" type="button" (click)="onMoveClick()" [disabled]="!hasSelectedOrders()">
          <span class="move-btn-content">
            Move Orders
            <img src="assets/booking-engine/icons/repeat.svg" alt="" class="move-icon" aria-hidden="true" />
          </span>
        </button>
      </div>
      <div class="move-mode-actions" *ngIf="showOnlySelected">
        <span class="selected-orders-text">
          {{ selectedOrdersCount }} Order(s) ready to move
        </span>
        <div class="button-group">
          <button class="btn outline" type="button" (click)="onMoveClick()">
            Show All Orders
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<input #uploadInput type="file" accept=".xlsx,.xls" style="display: none" (change)="!isReadOnly && onSelectImportDocument($event)" [disabled]="isReadOnly" />